import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreenCircleCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.1681L16.59 7.57812L18 8.99813L10 16.9981L6 12.9981L7.41 11.5881L10 14.1681Z",
		fill: "#14803C"
	})
});
export default SvgGreenCircleCheck;
